import { FilterableEntities } from "app/redux/filter/filter.reducer"

export type FilterActionTypes = {
  CHANGE_FILTERS: string
  RESET: string
  SET_FILTERABLE_FIELDS: string
}

const SET_FILTERABLE_FIELDS = "SET_FILTERABLE_FIELDS"

export function actionTypesFor(entityName: FilterableEntities): FilterActionTypes {
  return {
    CHANGE_FILTERS: `${entityName}_CHANGE_FILTERS`,
    RESET: `${entityName}_RESET`,
    SET_FILTERABLE_FIELDS,
  }
}

export type FilterActionResult<P = undefined> = {
  type: string
  payload?: P
}

export type Actions = {
  changeFilters: <Filters>(filters: Filters) => FilterActionResult<{ filters: Filters }>
  reset: () => FilterActionResult
}

export function actionsFor(entityName: FilterableEntities): Actions {
  const types = actionTypesFor(entityName)
  return {
    changeFilters: <Filters>(filters: Filters) => ({
      type: types.CHANGE_FILTERS,
      payload: { filters },
    }),
    reset: () => ({
      type: types.RESET,
    }),
  }
}

export const setFilterableFields = ({
  filterableFieldsValues,
  filterableField,
}: {
  filterableFieldsValues: string[]
  filterableField: string
}) => ({
  type: SET_FILTERABLE_FIELDS,
  payload: { filterableFieldsValues, filterableField },
})
